// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1PcsM","left":"InfoRow_left__1t-jB"};